export default __webpack_public_path__ + "locales/bg/DataReassignmentDialog.json?hash=a56eb9d1d46cd26562ca2c7e087c2ef4";